// @flow

import { rpCollectionsActions } from './rpCollectionsActionCreator';
import moment from 'moment';

const initialState = {
  isLoading: false,
  isKnockOffInProgress: false,
  isLoadingBalance: false,
  tableData: [],
  tableDataFiltered: [],
  amountBalance: null,
  vanNumber: null,
  fnfSettlementDto: {},
  orgCode: null,
  rpList: [],
  filterDates: {
    startDate: moment()
      .subtract(6, 'days')
      .startOf('day')
      .format('x'),
    endDate: moment()
      .endOf('day')
      .format('x')
  }
};

const rpCollectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case rpCollectionsActions.GET_AMOUNT_BALANCE: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case rpCollectionsActions.CONFIRM_FNF_AMOUNT: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case rpCollectionsActions.APPROVE_FNF_AMOUNT: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case rpCollectionsActions.GET_HANDOVER_PENDING_DATA: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case rpCollectionsActions.GET_HANDOVER_COMPLETED_DATA: {
      const { payload } = action;
      return { ...state, ...payload };
    }
    case rpCollectionsActions.SET_FILTER_DATES: {
      const { payload } = action;
      return { ...state, filterDates: payload };
    }
    case rpCollectionsActions.SET_KNOCK_OFF_LOADER: {
      const { payload } = action;
      return { ...state, isKnockOffInProgress: payload.isKnockOffInProgress };
    }
    case rpCollectionsActions.SET_RP_LIST: {
      return { ...state, rpList: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default rpCollectionsReducer;
